/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/football/match/redcard': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.795 18.308c-.095.89-.842 1.53-1.67 1.429l-7.054-.864c-.828-.102-1.423-.906-1.329-1.797L8.975 5.44c.095-.89.842-1.53 1.671-1.428l7.053.863c.828.102 1.423.906 1.328 1.797l-1.232 11.637z" _fill="#D71919"/><path pid="1" opacity=".198" fill-rule="evenodd" clip-rule="evenodd" d="M8.173 19.445c-.828-.101-1.423-.905-1.329-1.796L8.077 6.012c.022-.21.082-.405.17-.58H7.51c-.834 0-1.51.726-1.51 1.622v11.712c0 .897.676 1.623 1.51 1.623h7.098c.177 0 .346-.034.504-.094l-6.939-.85z" _fill="#D71919"/>'
  }
})
